import moment from 'moment';

export const formatDigitadoEmValue = (digitadoEm) => {
  if (digitadoEm == null || digitadoEm === '') return null;
  const parsed = moment(digitadoEm);
  return parsed.isValid() ? parsed.format('DD/MM/YYYY') : null;
};

export const computeSubNsmpStatus = (subNsmps) => {
  if (!Array.isArray(subNsmps) || subNsmps.length === 0) return null;

  let validado = 0;
  let invalidado = 0;

  subNsmps.forEach((sub) => {
    if (sub.validate === 'VALIDADO') validado += 1;
    else if (sub.validate === 'INVALIDADO') invalidado += 1;
  });

  const total = subNsmps.length;
  const aguardandoValidacao = total - validado - invalidado;

  return { total, validado, invalidado, aguardandoValidacao };
};

export const getDigitadoEmValue = (row) => {
  if (!row) return null;
  if (row.digitadoEmValue) return row.digitadoEmValue;
  return formatDigitadoEmValue(row.digitadoEm);
};

export const getInspecionadoEmValue = (row) => {
  if (!row) return null;
  if (row.inspecionadoEmValue) return row.inspecionadoEmValue;
  return formatDigitadoEmValue(row.inspecionadoEm);
};

const hasSituacaoPoste = (row) =>
  Boolean(row && row.situacaoPoste && String(row.situacaoPoste).trim());

export const isInspecionado = (row) =>
  Boolean(getInspecionadoEmValue(row) || hasSituacaoPoste(row));

export const getSubNsmpStatus = (row) => {
  if (!row) return null;
  if (Array.isArray(row.subNsmps) && row.subNsmps.length > 0) {
    return computeSubNsmpStatus(row.subNsmps);
  }
  if (row.subNsmpStatus) return row.subNsmpStatus;
  return null;
};

const isValidacaoSubNsmpConcluida = (subNsmpStatus) =>
  Boolean(
    subNsmpStatus
    && subNsmpStatus.total > 0
    && subNsmpStatus.aguardandoValidacao === 0
  );

const isDigitacaoEmAndamento = (subNsmpStatus) =>
  Boolean(
    subNsmpStatus
    && subNsmpStatus.aguardandoValidacao > 0
    && subNsmpStatus.total !== subNsmpStatus.aguardandoValidacao
  );

export const getStatusDigitacaoCode = (row) => {
  if (getDigitadoEmValue(row)) return '3';
  const subNsmpStatus = getSubNsmpStatus(row);
  if (isValidacaoSubNsmpConcluida(subNsmpStatus)) return '3';
  if (isDigitacaoEmAndamento(subNsmpStatus)) return '2';
  if (!isInspecionado(row)) return '0';
  return '1';
};

export const getStatusDigitacaoLabel = (row) => {
  if (getDigitadoEmValue(row)) return 'Digitação Finalizada';
  const subNsmpStatus = getSubNsmpStatus(row);
  if (isValidacaoSubNsmpConcluida(subNsmpStatus)) return 'Digitação Finalizada';
  if (isDigitacaoEmAndamento(subNsmpStatus)) return 'Digitação em andamento';
  if (!isInspecionado(row)) return 'Aguardando inspeção';
  return 'Aguardando Digitação';
};

/** Merge PUT/PATCH response into list row, preserving list projection fields. */
export const mergeNsmpForList = (previousRow, updatedData) => {
  const merged = { ...(previousRow || {}), ...updatedData };

  const digitadoEmValue = updatedData.digitadoEm != null
    ? formatDigitadoEmValue(updatedData.digitadoEm)
    : (merged.digitadoEmValue || (previousRow ? getDigitadoEmValue(previousRow) : null));

  let subNsmpStatus;
  if (Array.isArray(updatedData.subNsmps)) {
    subNsmpStatus = computeSubNsmpStatus(updatedData.subNsmps);
  } else if (merged.subNsmpStatus) {
    subNsmpStatus = merged.subNsmpStatus;
  } else if (previousRow) {
    subNsmpStatus = getSubNsmpStatus(previousRow);
  }

  return {
    ...merged,
    ...(digitadoEmValue ? { digitadoEmValue } : {}),
    ...(subNsmpStatus ? { subNsmpStatus } : {}),
  };
};
